import React from "react";
import BrandHeading from "@/components/brand/BrandHeading";
import BrandButton from "@/components/brand/BrandButton";
import BrandLabel from "@/components/brand/BrandLabel";

const NotFound = () => (
  <div className="container-rail py-24 text-center" data-testid="not-found">
    <BrandLabel withRule>404</BrandLabel>
    <BrandHeading level={1} className="mt-4">A page that doesn't exist.</BrandHeading>
    <p className="mt-4 max-w-[48ch] mx-auto text-muted-foreground">Try one of the brand homes.</p>
    <div className="mt-8 flex flex-wrap gap-3 justify-center">
      <BrandButton to="/">GMH</BrandButton>
      <BrandButton to="/castlewood" variant="secondary">Castlewood</BrandButton>
      <BrandButton to="/vela" variant="secondary">Vela</BrandButton>
      <BrandButton to="/brionj" variant="secondary">Brionj</BrandButton>
    </div>
  </div>
);
export default NotFound;
